export default __webpack_public_path__ + "static/788-9595392e0c26beeea6df08a261862dc3.gif";